import React from 'react';
import styles from './homeMenuIntro.module.scss';
import main from '../../../assets/images/MainMenu.webp'

const homeMenuIntro = () => (
  <div className={[styles.wrapper].join(' ')}>
  <div className={[styles.container].join(' ')}>
    <div className={[styles.imgBlock, 'col-xl-6', 'col-lg-12', 'col-12', 'px-0'].join(' ')}>
      <img  loading="lazy" src={main} alt="龍寶寶主選單" />
    </div>
    <div className={[styles.textBlock,'col-xl-6', 'col-lg-12', 'col-12', 'px-0'].join(' ')}>
      <div className={[styles.textBlockInner].join(' ')}>
        <h3>當你忘記指令時，</h3>
        <h3>請輸入「龍寶寶」叫出主選單</h3>
        <p>
          在這裡，可以總覽龍寶寶所有的功能。「新增帳款」提供直覺的介面處理各種情境的花費；「快速指令」提供各種功能的快捷指令，打字輸入還是最快速的方法！
        </p>
      </div>
    </div>
  </div>
  </div>
)

export default homeMenuIntro;
